<template>
  <div class="menu">
    <div class="menu__social" v-if="withSocialShare">
      <!-- TODO: For now now hide social share -->
      <SocialShare v-if="false"></SocialShare>
      <!-- <BtnDownload></BtnDownload> -->
    </div>
    <div class="menu__content">
      <!-- home button -->
      <MenuBox :data="homeButton"></MenuBox>

      <!-- sources -->
      <MenuBox
        v-for="(type, index) in sourcesTypes"
        :key="index"
        :data="getItemsBySourceType(type)"
        :title="type"
        linkType="router"
      ></MenuBox>

      <MenuBox
        linkType="modal"
        :data="modalLinks"
        :useMenuItem="false"
      ></MenuBox>

      <MenuBox
        linkType="external"
        :data="externalLinks"
        :useMenuItem="false"
      ></MenuBox>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import SocialShare from "@/components/SocialShare.vue";
// import BtnDownload from "@/components/BtnDownload.vue";
import MenuBox from "@/components/MenuBox.vue";

export default {
  components: {
    SocialShare,
    // BtnDownload,
    MenuBox,
  },
  data() {
    return {
      sourcesTypes: ["Renewables", " "],
    };
  },
  computed: {
    withSocialShare() {
      return this.landingIndex > -1;
    },
    content() {
      return this.$t("headerAndMenu").items;
    },
    homeButton() {
      return [this.content.find((x) => x.linkType === "router")];
    },
    modalLinks() {
      return this.content.filter((x) => x.linkType === "modal" && !x.hidden);
    },
    externalLinks() {
      return this.content.filter((x) => x.linkType === "external");
    },

    ...mapGetters({
      mainSourcesRegistry: "ui/mainSourcesRegistry",
      landingIndex: "scroller/landingIndex",
    }),
  },

  methods: {
    getItemsBySourceType(sourceType) {
      let res = [];

      const sourceArray = this.mainSourcesRegistry.filter(
        (x) => x.sourceType.trim() == sourceType.trim()
      );

      sourceArray.forEach((x) => {
        const obj = {
          title: x.name,
          key: x.key,
          text: x.name,
          routeParam: x.key,
          linkType: "router",
          landingIndex: x.landingIndex
        };
        res.push(obj);
      });

      return res;
    },
    ...mapActions({
      toggleMenu: "ui/toggleMenu",
    }),
  },
};
</script>

<style lang="scss" scoped>
.menu {
  height: 100%;
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;

  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;

  &__social {
    position: relative;
    display: flex;
    flex-flow: column;
    justify-content: center;
    align-items: center;
    min-width: toRem($landing-side-WIDTH);
    height: 100vh;
    transform: translateY(-2.5rem);
    // border-right: $white-border;
  }

  &__content {
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    width: 100%;
    height: 100%;
    margin-left: calc(toRem($landing-side-WIDTH) + $background-lines-WIDTH);
  }
}
</style>
